import { TOCCO_EVENT_METHOD_KEYS, TOCCO_EVENT_TYPE_KEYS, buildToccoEventSearchQuery } from './toccoEventSearchParams'

export interface ToccoEventSuggestion {
  id: string
  title: string
  url: string
}

export const useToccoEventSearch = () => {
  const { languageCode } = useLocale()
  const localePath = useLocalePath()

  const keyword = ref('')
  const suggestions = ref<ToccoEventSuggestion[]>([])
  const controller = ref<AbortController | null>(null)

  const getSuggestions = async () => {
    controller.value?.abort()

    if (keyword.value.length < 3) {
      suggestions.value = []
      return
    }

    const abortController = new AbortController()
    controller.value = abortController

    try {
      suggestions.value = await $fetch<ToccoEventSuggestion[]>('/api/elasticsearch/tocco-events-suggest', {
        query: { q: keyword.value, langcode: languageCode.value },
        signal: abortController.signal,
      })
    } catch (error) {
      if (!abortController.signal.aborted) {
        console.error(error)
      }
    }
  }

  const submit = ({
    typeSelection = TOCCO_EVENT_TYPE_KEYS,
    methodSelection = TOCCO_EVENT_METHOD_KEYS,
  }: {
    typeSelection?: readonly string[]
    methodSelection?: readonly string[]
  } = {}) => {
    controller.value?.abort()
    suggestions.value = []
    navigateTo({
      path: localePath('/weiterbildung/suche'),
      query: buildToccoEventSearchQuery({ q: keyword.value, typeSelection, methodSelection }),
    })
  }

  const selectSuggestion = (suggestion: ToccoEventSuggestion) => {
    controller.value?.abort()
    suggestions.value = []
    navigateTo(suggestion.url)
  }

  return {
    keyword,
    suggestions,
    getSuggestions,
    selectSuggestion,
    submit,
  }
}
